export function createHeaders(accessToken,oktaIdToken) {
  const headers = {
      "AccessToken": accessToken,
      "OktaIdToken": oktaIdToken
  };
  return headers;
}